"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddPronunciationDictionaryResponseModelPermissionOnResource = void 0;
exports.AddPronunciationDictionaryResponseModelPermissionOnResource = {
    Admin: "admin",
    Editor: "editor",
    Viewer: "viewer",
};
